export enum responseCodes {
  BR4001 = "BR4001",
}